import { render, staticRenderFns } from "./SiteIndexComponent.vue?vue&type=template&id=3c71fdfa"
import script from "./SiteIndexComponent.vue?vue&type=script&lang=js"
export * from "./SiteIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports